export default {
  name: 'marking--importThirdCountryM',
  apiService: 'shoes',
  apiPath: '/admin/import_m',
};
